module.exports = __webpack_public_path__ + "static/img/EG.47587a3a.png";